// The agency's /finance API (finance redesign slice 3): one read per tab and the agency's cash.
// Admin only: the admin apiClient, as every finance service (AdminLayout mounts no HttpClientProvider). It throws an
// HttpError carrying the server's message on a 4xx (TD-093). To do and Clients on jobs (finance consolidation S9) read
// main's paths in their new shapes as `jobsToDo` and `jobClients`; Cash on jobs keeps `cash`'s shape.
import { apiClient } from "@/services/apiClient";
import type {
  AgencyCashInput, AgencyCashRead, AgencyCashView, AgencyExpenses, AgencyTeam, CashDays, JobClientRow, JobClients, JobClientsShow, JobsToDo,
} from "../types";

const BASE = "/api/finance";

export const agencyService = {
  team: () => apiClient.get<AgencyTeam>(`${BASE}/agency/team`),
  expenses: () => apiClient.get<AgencyExpenses>(`${BASE}/agency/expenses`),
  /** Cash for `days` either side of today (slice 4). */
  cash: (days: CashDays) => apiClient.get<AgencyCashView>(`${BASE}/agency/cash?days=${days}`),
  /** The agency's cash on a date (J18), or null. */
  agencyCash: () => apiClient.get<AgencyCashRead>(`${BASE}/agency-cash`),
  /** Replaces the agency's cash on a date. Answers as agencyCash. */
  setAgencyCash: (input: AgencyCashInput) => apiClient.put<AgencyCashRead>(`${BASE}/agency-cash`, input),
  /** To do on jobs: only the steps that move money, each group's total the server's (DD-041). */
  jobsToDo: () => apiClient.get<JobsToDo>(`${BASE}/agency/todo`),
  /** Clients on jobs: the tab's clients, every tab's count and the tab's footer. */
  jobClients: (show: JobClientsShow) => apiClient.get<JobClients>(`${BASE}/agency/clients?filter=${show}`),
  /** One client's row, for its drawer's strip; null when it has none. */
  clientRow: (clientId: string) => apiClient.get<JobClientRow | null>(`${BASE}/agency/clients/${clientId}`),
};
